import { Button, Icon, UncontrolledTooltip } from '@polichat/flamboyant';
import { useCallback, useEffect, useState } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ChatActions from '../../../../store/modules/chat/actions';

import { isMobile } from 'react-device-detect';

function TriggerSuggestionScreenFilter({
  // constants
  activeNavigation,
  hasAsyncRequest,

  openChatTab,
  openTriggerSuggestionTab,
  removeFilter,
}) {
  const [activeTabNavigation, setActiveTabNavigation] = useState();
  // Usado para permitir ou não o clique na aba de trigger suggestion
  const somethingIsLoading = hasAsyncRequest;

  useEffect(() => {
    setActiveTabNavigation(activeNavigation);
  }, [activeNavigation]);

  const handleNavigation = useCallback(() => {
    // Remove Filter é importante para o funcionamento dos filtros
    if (isMobile) {
      let contactPanelMobile = document.querySelector(
        '.contactPanelMobile'
      )?.classList;
      if (contactPanelMobile) {
        document.querySelector('.chatPanelContainer')?.classList.add('hidden');
        contactPanelMobile?.toggle('hidden');
      }
    }
    removeFilter('chat');
    removeFilter('contact');
    if (activeTabNavigation === 'triggerSuggestion') {
      openChatTab();
    } else {
      openTriggerSuggestionTab();
    }
  }, [
    activeTabNavigation,
    removeFilter,
    openChatTab,
    openTriggerSuggestionTab,
  ]);

  if (activeTabNavigation) {
    return (
      <div className="filter-content" id="triggerSuggestionNavigation">
        <div className="dropdown">
          <Button
            className="btnFilterDropdown"
            color="light"
            boder="border-none"
            onClick={() =>
              !somethingIsLoading
                ? handleNavigation()
                : console.log(
                    'Espere o carregamento terminar para clicar. TriggerSuggestionScreenFilter()'
                  )
            }
          >
            {activeTabNavigation === 'triggerSuggestion' ? (
              <>
                <Icon icon="poli-icon pi-close" size={16} />
                <UncontrolledTooltip
                  placement="bottom"
                  target="triggerSuggestionNavigation"
                >
                  Fechar Trigger Suggestion
                </UncontrolledTooltip>
              </>
            ) : (
              <>
                <Icon icon="poli-icon pi-rocket-fill" size={16} />
                <UncontrolledTooltip
                  placement="bottom"
                  target="triggerSuggestionNavigation"
                >
                  Abrir Sugestão de Disparo
                </UncontrolledTooltip>
              </>
            )}
          </Button>
        </div>
      </div>
    );
  }
  return <></>;
}

const mapStateToProps = (state) => ({
  // constants
  activeNavigation: state.chat?.config?.activeTabNavigation,
  hasAsyncRequest: state.chat?.hasAsyncRequest,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(ChatActions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TriggerSuggestionScreenFilter);
